import React, { useState } from 'react';

export default function LazyImg({ src, alt, style, onError, ...rest }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onLoad={() => setLoaded(true)}
      onError={e => { onError && onError(e); }}
      style={{
        ...style,
        opacity: loaded ? 1 : 0,
        transition: 'opacity 0.4s ease',
        background: 'linear-gradient(135deg,#1c1008 0%,#2a1510 50%,#1c1008 100%)',
      }}
      {...rest}
    />
  );
}
